export default __webpack_public_path__ + "dist/media/Add-user.ee9555f0.svg";